import React from 'react';

import Result from '@/pages/headhunters/[orgId]/_lib/Result';

const RecommendResult = (props) => {
  return <Result {...props} />;
};

export default RecommendResult;
